<ng-container *ngIf="!item.hidden">
  <!-- collapsible title -->
  <a
    class="d-flex align-items-center"
    [ngClass]="item.classes"
    [ngClass]="item.type == 'section' ? 'dropdown-toggle nav-link' : 'dropdown-item dropdown-toggle'"
    *ngIf="!item.url"
  >
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </a>

  <!-- itemContent template -->
  <ng-template #itemContent>
    <!-- El icono puede ser un nombre de lucide, una clase de fuente o una imagen subida -->
    <app-lucide-icon class="menu-icon-lucide" [name]="lucideIconName(item.icon)" [size]="18"
                     *ngIf="isLucideIcon(item.icon)"></app-lucide-icon>
    <img class="menu-icon-img" [src]="item.icon" alt="" *ngIf="isImageIcon(item.icon)" />
    <span [ngClass]="item.icon" class="fa-lg fa-fw" *ngIf="(item.icon && !isLucideIcon(item.icon) && !isImageIcon(item.icon) && item.icon.startsWith('fa'))"></span>
    <span [data-feather]="item.icon" *ngIf="(item.icon && !isLucideIcon(item.icon) && !isImageIcon(item.icon) && !item.icon.startsWith('fa'))"></span>
    <span class="menu-title">{{ label }}</span>
  </ng-template>

  <!-- sub-menu item/collapsible -->
  <ul class="dropdown-menu">
    <ng-container *ngFor="let item of item.children">
      <!-- item -->
      <li
        core-menu-horizontal-item
        *ngIf="
          item.type == 'item' && (item.role ? item.role.includes(currentUser.role) : false || item.role == undefined)
        "
        [item]="item"
        [ngClass]="{ disabled: item.disabled === true }"
        [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
        [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
      >
        <span [routerLink]="item.openInNewTab ? [] : [item.url]" class="d-none"></span>
      </li>
      <!-- collapsible -->
      <li
        core-menu-horizontal-collapsible
        *ngIf="
          item.type == 'collapsible' &&
          (item.role ? item.role.includes(currentUser.role) : false || item.role == undefined)
        "
        [item]="item"
        class="dropdown dropdown-submenu"
      ></li>
    </ng-container>
  </ul>
</ng-container>
